import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';
import { covidAcknowledgementFlow } from './covid-acknowledgement.flow';
import { greetingsWelcomeFlow } from './greetings-welcome.flow';
import { qrCodeValidationFlow } from './qr-code-validation.flow';

export enum CovidDeclarationStep {
  Start = 'Start',
  AfterCovid = 'AfterCovid',
  ScanQr = 'ScanQr',
  AfterQrValidation = 'AfterQrValidation',
  AfterGreeting = 'AfterGreeting',
  RecordAcknowledgement = 'RecordAcknowledgement',
}

export const covidDeclarationFlow: CheckinWorkflow<CovidDeclarationStep> = {
  id: FlowId.CovidDeclaration,
  entry: CovidDeclarationStep.Start,
  steps: {
    [CovidDeclarationStep.Start]: {
      id: CovidDeclarationStep.Start,
      next: (variables) =>
        variables.checkinProcessConfiguration?.hasCoronavirusScreen
          ? { flow: covidAcknowledgementFlow, returnStep: CovidDeclarationStep.AfterCovid }
          : { nextStep: CovidDeclarationStep.ScanQr },
      back: () => ({ bubble: 'back' }),
      exit: () => ({ bubble: 'exit' }),
    },
    [CovidDeclarationStep.AfterCovid]: {
      id: CovidDeclarationStep.AfterCovid,
      next: () => ({ nextStep: CovidDeclarationStep.ScanQr }),
    },
    [CovidDeclarationStep.ScanQr]: {
      id: CovidDeclarationStep.ScanQr,
      next: () => ({
        flow: qrCodeValidationFlow,
        returnStep: CovidDeclarationStep.AfterQrValidation,
      }),
      back: (variables) =>
        variables.checkinProcessConfiguration?.hasCoronavirusScreen
          ? { nextStep: CovidDeclarationStep.Start }
          : { bubble: 'back' },
      exit: () => ({ bubble: 'exit' }),
    },
    [CovidDeclarationStep.AfterQrValidation]: {
      id: CovidDeclarationStep.AfterQrValidation,
      next: () => ({ flow: greetingsWelcomeFlow, returnStep: CovidDeclarationStep.AfterGreeting }),
      back: () => ({ nextStep: CovidDeclarationStep.ScanQr }),
      exit: () => ({ bubble: 'exit' }),
    },
    [CovidDeclarationStep.AfterGreeting]: {
      id: CovidDeclarationStep.AfterGreeting,
      next: () => ({ nextStep: CovidDeclarationStep.RecordAcknowledgement }),
    },
    [CovidDeclarationStep.RecordAcknowledgement]: {
      id: CovidDeclarationStep.RecordAcknowledgement,
      page: PageKey.COVID_RECORD,
      next: () => ({ complete: true }),
    },
  },
};
